import { render } from "./testimonialSection.vue?vue&type=template&id=8f21d756&scoped=true"
import script from "./testimonialSection.vue?vue&type=script&lang=js"
export * from "./testimonialSection.vue?vue&type=script&lang=js"

import "./testimonialSection.vue?vue&type=style&index=0&id=8f21d756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f21d756"]])

export default __exports__